function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
import * as geoGouvAutocompleteInput from 'elements/../geo-gouv-autocomplete-input';
export var pcsPageRegister = new ( /*#__PURE__*/function () {
  function PcsPageRegister() {
    var _this = this;
    _classCallCheck(this, PcsPageRegister);
    vent.on('APP:READY', function (_) {
      if ($('.pcs-page-register').length) _this.init();
    });
  }
  _createClass(PcsPageRegister, [{
    key: "init",
    value: function init() {
      //
      var defaultValue = $('#location_name').val() !== '' ? {
        name: $('#location_name').val(),
        citycode: $('#location_id').val()
      } : null;
      var updateLocation = function updateLocation(name, code) {
        $('.pcs-auth__form-submit button').attr('disabled', 'disabled');
        $('#location_name').val(name);
        $('#location_id').val(code);
        $('#location_name_honor').text(name);
        if (name !== '' && code !== '') {
          $('.pcs-auth__form-submit button').removeAttr('disabled');
        }
      };
      $('#location_name-suggest-container').geoGouvAutocompleteInput({
        defaultValue: defaultValue,
        id: 'location_name-suggest'
      }).on('geo-gouv-result', function (e, data) {
        if (data && data.name && data.citycode) {
          updateLocation(data.name, data.citycode);
        } else {
          updateLocation('', '');
        }
      });
    }
  }]);
  return PcsPageRegister;
}())();